import React from 'react'
import PropTypes from 'prop-types'

import styles from './radio-input.css'
import classNames from 'classnames'

class RadioInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedValue: props.value,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ selectedValue: this.props.value })
    }
  }

  handleItemClick(event) {
    const { target: { name, value } } = event
    this.setState({ selectedValue: value }, () => {
      this.props.onChange(value, name)
    })
  }

  render() {
    const {
      customClass,
      customOptionContainerClass,
      customOptionClass,
      selectedOptionClass,
      options,
      label,
      name,
      disabled,
      fancy,
      buttonToTop,
      dataQsId,
    } = this.props
    const { selectedValue } = this.state

    const radioOptions = options.map((option, index) => {
      const { value, label, dangerousInnerHtml = false } = option
      const selectedClass = selectedOptionClass && selectedValue === value ? selectedOptionClass : null

      const labelElement = dangerousInnerHtml
        ? (<span className={styles.itemLabel} dangerouslySetInnerHTML={{ __html: label }} />)
        : (<span className={classNames(styles.itemLabel, { [styles.fancy]: fancy })}>{label}</span>)

      const labelClass = classNames(
        `${styles.item} ${customOptionClass || ''} ${selectedClass}`,
        {
          [styles.checked]: selectedValue === value,
          [styles.fancy]: fancy,
          [styles.buttonToTop]: buttonToTop,
        })

      return (
        <label key={index} className={labelClass}>
          <input
            type="radio"
            name={name}
            value={value}
            className={classNames(styles.itemInput, { [styles.fancy]: fancy })}
            checked={(selectedValue === value)}
            onClick={this.handleItemClick.bind(this)}
            disabled={disabled}
            readOnly />
          {labelElement}
        </label>
      )
    })

    const labelEl = label
      ? <label className={styles.label}>{label}</label>
      : null

    return (
      <div className={`${styles.container} ${customClass || ''}`} data-qs-id={dataQsId}>
        {labelEl}
        <div className={`${styles.options} ${customOptionContainerClass || ''}`}>
          {radioOptions}
        </div>
      </div>
    )
  }
}
RadioInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  options: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  customOptionClass: PropTypes.string,
  customClass: PropTypes.string,
  dataQsId: PropTypes.string.isRequired,
}

RadioInput.defaultProps = {
  name: '',
  value: '',
  options: [],
  customOptionContainerClass: '',
  customOptionClass: '',
  customClass: '',
}

export default RadioInput
